export const CELL_DROPDOWN_TYPE = 'Dropdown';
export const CELL_MULTISELECT_TYPE = 'Multiselect';
